<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>Statutory Compliances</h3>
        <h4>1/4</h4>
      </div>
      <div class="row d-flex justify-content-center">
        <form class="col-xl-6" [formGroup]="form">
          <div class="my-4">
            <div class="form-check form-switch">
              <label class="form-check-label" for="pf">PF (Provident Fund) Applicable</label>
              <input
                appTrimInput
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="pf"
                formControlName="pf"
              />
            </div>
          </div>
          <div *ngIf="form.get('pf')?.value" class="d-inline-block border rounded-2 ms-2 px-2 py-0">
            <div class="my-2">
              <div class="form-check form-switch">
                <label class="form-check-label" for="eps"
                  >EPS (Employee Pension Scheme) Applicable</label
                >
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="eps"
                  formControlName="eps"
                />
              </div>
            </div>
            <div class="my-2">
              <div class="form-check form-switch">
                <label class="form-check-label" for="employerCapping"
                  >Employer PF capped at 1800 / month</label
                >
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="employerCapping"
                  formControlName="employerCapping"
                />
              </div>
            </div>
          </div>
          <div class="my-4">
            <div class="form-check form-switch">
              <label class="form-check-label" for="esi"
                >ESI (Employee State Insurance) Applicable</label
              >
              <input
                appTrimInput
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="esi"
                formControlName="esi"
              />
            </div>
          </div>
          <div class="my-4">
            <div class="form-check form-switch">
              <label class="form-check-label" for="lwf"
                >LWF (Labour Welfare Fund)) Applicable</label
              >
              <input
                appTrimInput
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="lwf"
                formControlName="lwf"
              />
            </div>
          </div>
          <div class="my-4">
            <div class="form-check form-switch">
              <label class="form-check-label" for="pt">PT (Professional Tax) Applicable</label>
              <input
                appTrimInput
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="pt"
                formControlName="pt"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
